import { useEffect, useState } from "react";
import { api } from "../../services/api";
import TableSys from "../generic/TableSys";

export default function TableGroups({handleEdit, handleUsers, clients}) {


  const headCells = [
    { id: "name", numeric: false, label: "Perfil", order: 1 },
    { id: "action_edit", numeric: false, label: "Editar", order: 2 },
    { id: "count_users", numeric: false, label: "Usuários", order: 3 },
  ];

  return <TableSys handleUsers={handleUsers} idPage={1} header={headCells} dados={clients} handleEdit={handleEdit}></TableSys>;
}
